import React from "react";
import { DialogContent as MUIDialogContent } from "@mui/material";
import styled from "styled-components";

const StyledMUIDialogContent = styled(MUIDialogContent)``;

export const DialogContent = (props) => {
  return <StyledMUIDialogContent {...props} />;
};
